import React from "react";
import {Outlet} from "react-router-dom";
import AdminSettingNavTab from "./AdminSettingNavTab";

function AdminClientSettings() {

    return (
        <section className="section-bg-color setting_tab"
                 style={{minHeight: "calc(100vh - 139px)", overflowX: "hidden",  marginTop:"6.6vh"}}>
            <div className="custom_container">
                <div className="row">
                    <AdminSettingNavTab/>

                    <div className="col-md-9">
                        <div className="tab-content bg_transparent" id="nav-tabContent"
                             style={{minHeight: "calc(100vh - 137px)", marginBottom: 30}}>

                            <Outlet/>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AdminClientSettings;